<template>
    <div class='footer'>
        <div class='footer-1'>
            <span @click="openPrivacy">隐私协议</span>
<!--            <span @click="openMainBody">主体信息</span>-->
        </div>
        <div class='footer-2'>
            <div class='footer-2-left'>
                <div><img src="../assets/footer_icon_iphone.png" class='footer-icon' />手机：18012485542</div>
                <div><img src="../assets/footer_icon_email.png" class='footer-icon' />邮箱：best-idphoto@venpoo.com</div>
                <div><img src="../assets/footer_icon_address.png" class='footer-icon' />总部：无锡市新吴区菱湖大道111号无锡软件园天鹅座D座1601室
                </div>
                <!-- <div><img src="../assets/footer_icon_address.png" class='footer-icon' />客服中心：无锡市滨湖区金融街区一支路11号平安财富中心14楼</div> -->
            </div>
            <div class='footer-2-middle'>
                <div>
                    <img src="../assets/footer_icon_landline.png" class='footer-icon' />联系我们
                </div>
                <div>
                    0510-81819939
                </div>
                <div>
                    咨询时间：周一至周五8：30-11：30 , 13：00-17:30
                </div>
            </div>
            <div class='footer-2-right'>
                <img src="../assets/wxsqrcode.png" />
                <div>扫码关注微信公众号</div>
            </div>
        </div>
        <div class='footer-3'>
            Copyright © 2019 无锡乐骐科技股份有限公司 |  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32021402001005">苏公网安备 32021402001005号</a> <a target="_blank" href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action">苏ICP备14019013号-8</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PageFooter1',
        methods:{
            openPrivacy:function(){
                window.open("http://www.id-photo-verify.com/privacy-zuimei-personal/")
            },
            openMainBody:function(){
                window.open("https://id-photo-verify.com/leqi/")
            }
        },
    }
</script>

<style scoped="scoped">
    .footer>div{
        padding: 0 19%;
    }
    .footer-1{
        line-height:50px;
        color:rgba(102,102,102,1);
        font-size:14px;
        background:rgba(249,249,249,1);
    }
    .footer-1 span{
        display: inline-block;
        margin-right: 60px;
        cursor:pointer
    }
    .footer-2{
        height: 172px;
        background:rgba(253,253,253,1);
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .footer-2>div{
        display: inline-block;
    }
    .footer-2-left>div{
        color:rgba(51,51,51,1);
        font-size:12px;
        display: flex;
        align-items: center;
        margin: 16px 0;
    }
    .footer-2-left .footer-icon{
        margin-right: 14px;
    }
    .footer-2-middle div:nth-child(1){
        font-size:16px;
        color:rgba(51,51,51,1);
        display: flex;
        align-items: center;
    }
    .footer-2-middle div:nth-child(2){
        font-family:DINAlternate;
        font-weight:bold;
        font-size:34px;
        color:rgba(51,51,51,1);
        margin-top: 7px;
        margin-bottom: 4px;
    }
    .footer-2-middle div:nth-child(3){
        margin-right: 6px;
        font-size: 12px;
    }
    .footer-2-middle .footer-icon{
        margin-right: 14px;
    }
    .footer-2-right{
        width: 140px;
    }
    .footer-2-right img{
        width: 140px;
    }
    .footer-2-right div{
        font-size:12px;
        text-align: center;
        color:rgba(153,153,153,1);
    }
    .footer-3{
        font-size:12px;
        color:rgba(102,102,102,1);
        line-height:50px;
        background:rgba(249,249,249,1);
        text-align: center;
    }
    .footer-icon{
        width: 20px;
        height: 20px;
    }
</style>
